var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1543_57",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 23,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7599 22C14.0734 22.0017 15.3742 21.7438 16.5877 21.2412C17.8012 20.7385 18.9034 20.001 19.8309 19.071C20.7609 18.1435 21.4984 17.0413 22.0011 15.8278C22.5037 14.6143 22.7616 13.3135 22.7599 12C22.7616 10.6865 22.5037 9.3857 22.001 8.17222C21.4984 6.95875 20.7609 5.85656 19.8309 4.92901C18.9034 3.99902 17.8012 3.26151 16.5877 2.75885C15.3742 2.25619 14.0734 1.99831 12.7599 2.00001C11.4464 1.99833 10.1456 2.25623 8.93213 2.75889C7.71865 3.26154 6.61646 3.99904 5.68891 4.92901C4.75895 5.85656 4.02145 6.95875 3.51879 8.17222C3.01614 9.3857 2.75824 10.6865 2.75991 12C2.75821 13.3135 3.0161 14.6143 3.51875 15.8278C4.02141 17.0413 4.75892 18.1435 5.68891 19.071C6.61646 20.001 7.71865 20.7385 8.93213 21.2411C10.1456 21.7438 11.4464 22.0017 12.7599 22Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75992 12L11.7599 15L17.7599 9",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1543_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.759918 0H24.7599V24H0.759918V0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIcon);
export default __webpack_public_path__ + "static/media/active_icon.efc807dae02cf08a5a951f3b46019b7d.svg";
export { ForwardRef as ReactComponent };